<template>
    <div class="card mt-5">
        <div class="card-header p-4"><h4>Grafik Indikator Mutu Nasional</h4></div>
        <div class="card-body">
            <div class="row mb-5">
                <div class="col-md-12">
                    <form method="get" id="chart-national-form">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <input type="number" name="year" class="form-control year-datepicker" readonly="true" placeholder="Tahun" />
                            </div>
                            <div class="form-group col-md-6">
                                <select name="id" class="form-control indicator-select"></select>
                            </div>
                            <div class="col-md-3">
                                <button type="submit" class="btn btn-primary">
                                    <i class="la la-search"></i>&nbsp;&nbsp;Cari
                                </button>
                                <button type="button" class="btn btn-success" v-on:click="print()" :disabled="!detail">
                                    <i class="la la-print"></i>&nbsp;&nbsp;Print
                                </button>
                            </div>
                        </div>
                    </form>
                    <div class="d-flex align-items-center mb-10" role="status" v-if="loading">
                        <strong>Mohon tunggu...</strong>
                        <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                    </div>
                    <div id="national-table-print-area" class="table-responsive" v-if="detail">
                        <table class="table table-bordered">
                            <thead>
                                <tr class="valign-middle text-center">
                                    <th rowspan="2">No</th>
                                    <th rowspan="2" class="width-150">Indikator</th>
                                    <th :colspan="months.length">Bulan</th>
                                </tr>
                                <tr class="valign-middle text-center">
                                    <th class="width-50" v-for="(month, monthKey) in months" :key="monthKey">{{ month }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="valign-middle text-center">
                                    <th>1</th>
                                    <th class="text-left">{{ name }}</th>
                                    <th class="width-50" v-for="(month, monthKey) in months" :key="monthKey">{{ finalResults[monthKey] }}</th>
                                </tr>
                                <tr class="valign-middle text-center">
                                    <th></th>
                                    <th>TARGET</th>
                                    <th class="width-50" v-for="(month, monthKey) in months" :key="monthKey">{{ `${detail.target_indicator}${detail.target_unit}` }}</th>
                                </tr>
                                <tr class="valign-middle text-left" v-for="(reportIndicator, reportIndicatorKey) in detail.report_indicator_labels" :key="reportIndicatorKey">
                                    <td></td>
                                    <td>{{ reportIndicator ? reportIndicator.name : '-' }}</td>
                                    <td class="width-50" v-for="(month, monthKey) in months" :key="monthKey">{{ results[reportIndicatorKey][monthKey] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row justify-content-md-center" :class="{'d-none': !detail}">
                        <div class="col-md-8">
                            <canvas id="national-chart"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js/auto'

    export default {
        name: 'NationalChart',
        components: {Chart},
        props: {
            months: {
                type: Array,
                default: () => ([])
            }
        },
        data() {
            return {
                loading: false,
                values: [],
                detail: null,
                results: [],
                finalResults: [],
                ctx: null,
                chart: {},
                searchParams: {
                    year: null,
                    id: null,
                },
                targets: [],
            }
        },
        computed: {
            name() {
                return this.detail ? this.detail.indicator.name : '-'
            }
        },
        mounted() {
            const app = this
            $('#chart-national-form').find('.year-datepicker').change(function() {
                const params = { year: $(this).val() }
                const selectIndicators = $('#chart-national-form').find('.indicator-select');
                axios.get('/ajax/national-indicators', { params }).then(({data}) => {
                    selectIndicators.find('option').remove()
                    selectIndicators.select2().val(null).trigger('change')
                    selectIndicators.select2({placeholder: "Pilih Indikator", data}).trigger('change')
                })
            })
            $('#chart-national-form').submit(function(e) {
                e.preventDefault()
                const params = $(this).serialize()
                $.each($(this).serializeArray(), function() {
                    app.searchParams[this.name] = this.value
                })
                app.loading = true
                axios.get(`/ajax/report-national?${params}`).then(({data}) => {
                    app.detail = data.detail
                    app.values = data.values
                    app.loading = false
                    app.detail.report_indicator_labels.map((item, key) => {
                        app.results[key] = []
                        app.months.map((month, monthKey) => {
                            const exist = app.values.find((val) =>
                                val.indicator_id == app.detail.indicator_id &&
                                val.report_indicator_id == item.report_indicator_id &&
                                val.input_month == monthKey + 1)
                            app.results[key][monthKey] = exist ? exist.value : null
                        })
                    })
                    app.months.map((month, monthKey) => {
                        let formula = `${app.detail.indicator_formula}`
                        app.results.map((item, key) => {
                            const alphabet = app.alphabet(key)
                            let val = app.results[key][monthKey] ? app.results[key][monthKey] : 0
                            formula = formula.replace(`[${alphabet}]`, val)
                        })
                        app.finalResults[monthKey] = app.normalizeEval(formula)
                        app.targets[monthKey] = app.detail.target_indicator
                    })
                    app.updateChart()
                })
            })
            app.renderChart()
        },
        methods: {
            print() {
                const dataUrl = document.getElementById('national-chart').toDataURL('image/png', 0.1)
                let windowContent = '<!DOCTYPE html>'
                windowContent += '<html>'
                windowContent += '<head>'
                windowContent += `<title>${this.name}</title>`
                windowContent += "<link href='/css/app.css' rel='stylesheet' media='screen,print'>"
                windowContent += '</head>'
                windowContent += '<body>'
                windowContent += document.getElementById('national-table-print-area').innerHTML
                windowContent += '<img src="' + dataUrl + '" style="width:100%">'
                windowContent += '</body>'
                windowContent += '</html>'
                let printWin = window.open('','','width=640,height=460')
                if(!printWin || printWin.closed || typeof printWin.closed=='undefined')
                {
                    swal.fire('Cannot print, Browser cannot support')
                    return
                }
                printWin.document.open()
                printWin.document.write(windowContent)
                printWin.document.close()
                printWin.focus()
                setTimeout(() => {
                    printWin.print()
                    printWin.onafterprint = function() {
                        printWin.close()
                    }
                }, 200)
            },
            updateChart() {
                this.chart.options = {
                    plugins: {
                        title: {
                            display: true,
                            text: [
                                this.name,
                                'RSPG Cisarua Bogor',
                                `Tahun ${this.searchParams.year}`
                            ]
                        }
                    },
                }
                this.chart.data = {
                    labels: this.months,
                    datasets: [{
                        label: 'TARGET',
                        data: this.targets,
                        backgroundColor: ['#4ac24c'],
                        borderColor: ['#4ac24c'],
                        borderWidth: 1
                    },
                    {
                        label: "CAPAIAN",
                        data: this.finalResults,
                        backgroundColor: ['#4c4ac2'],
                        borderColor: ['#4c4ac2'],
                        borderWidth: 1
                    }]
                }
                this.chart.update()
            },
            renderChart() {
                this.ctx = document.getElementById('national-chart')
                var ctx = this.ctx.getContext('2d')
                this.chart = new Chart(ctx, {
                    type: 'line',
                    data: {},
                    options: {
                        responsive: true,
                        scales: {
                            x: {
                                display: true
                            },
                            y: {
                                display: true,
                                beginAtZero: true
                            }
                        }
                    }
                })
            }
        }
    }
</script>
